import React from 'react';

import { PrizeDistributionModalTabs } from '../../../../types';
import GameCards from '../GameCards/GameCards';
import styles from '../shared.scss';

import type { PrizeDistributionContentProps } from './PrizeDistributionContent';
import PrizeDistributionContent from './PrizeDistributionContent';

const HoldemMaxMobileContent: React.FC<PrizeDistributionContentProps> = ({
  selectedTab,
  playerCount,
  weights,
  buyIn,
  timeBank,
  initialChips,
  gameType,
  drawLevels,
  modLevels,
  currency,
  scalePM,
  buyin,
  rake,
  lowBet,
  highBet
}) => (
  <>
    {selectedTab === PrizeDistributionModalTabs.information && (
      <GameCards
        buyIn={buyIn}
        timeBank={timeBank}
        players={modLevels?.[0].numUsers}
        chip={initialChips}
        tab={gameType}
        playerCount={playerCount}
        weights={weights}
        selectedTab={selectedTab}
        lowBet={lowBet}
        highBet={highBet}
      />
    )}
    {selectedTab === PrizeDistributionModalTabs.prizes && (
      <div className={styles.holdemContainer}>
        <PrizeDistributionContent
          selectedTab={selectedTab}
          playerCount={playerCount}
          weights={weights}
          buyIn={buyIn}
          timeBank={timeBank}
          initialChips={initialChips}
          gameType={gameType}
          drawLevels={drawLevels}
          modLevels={modLevels}
          currency={currency}
          scalePM={scalePM}
          buyin={buyin}
          rake={rake}
          lowBet={lowBet}
          highBet={highBet}
        />
      </div>
    )}
  </>
);

export default HoldemMaxMobileContent;
